// dashboard/index.tsx
import React, { useState } from "react";
import classNames from "classnames";

import Leftbar from "./Leftbar";
import UserProfileDetails from "./UserProfileDetails/index";

import Welcome from "./ConversationUser/Welcome";
import ConversationUser from "./ConversationUser/index";
import { useChat } from "../../context/ChatContext";

const Dashboard = () => {
  const { selectedChatId, canSendText, chatUserDetails } = useChat();

  /** ------------------- STATES ------------------- **/
  const [isOpenPanel, setIsOpenPanel] = useState(false);
  const [isChannel, setIsChannel] = useState<boolean>(false);

  /** ------------------- PAINEL PROFILE USER HANDLERS ------------------- **/
  const openProfilePanel = () => setIsOpenPanel(true);
  const onCloseProfilePanel = () => setIsOpenPanel(false);

  const safeUser = chatUserDetails;

  const isBlocked =
    !!safeUser?.basicDetails.blockedMessage &&
    new Date(safeUser.basicDetails.blockedMessage) > new Date();

  return (
    <>
      <Leftbar />

      <div
        className={classNames("user-chat w-100 overflow-hidden", {
          "user-chat-show": selectedChatId,
        })}
        id="user-chat"
      >

        <div className="user-chat-overlay" id="user-chat-overlay">

        </div>

        {selectedChatId !== null ? (
          <div className="chat-content d-lg-flex">
            <div className="w-100 overflow-hidden position-relative">
              <ConversationUser
                openUserDetails={openProfilePanel}
                isChannel={isChannel}
                isBlocked={isBlocked}
                canSendFreeText={canSendText}
              />
            </div>

            <UserProfileDetails
              isChannel={isChannel}
              isOpen={isOpenPanel}
              isBlocked={isBlocked}
              canSendFreeText={canSendText}
              onClose={onCloseProfilePanel}
            />
          </div>
        ) : (
          <Welcome />
        )}
      </div>
    </>
  );
};

export default Dashboard;
